// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__y2JGl","detailsBorder":"styles_detailsBorder__17ixM"};